const getDivisaoCnaeFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  {
    name: 'secao_cnae',
    label: 'Seção CNAE',
    type: 'select',
    options: drops?.SecaoCnae,
    multiple: true,
  },
  { name: 'codigo', label: 'Código' },
];

export default getDivisaoCnaeFilterFields;
